var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-pagination',{attrs:{"right":"","value":_vm.page,"length":_vm.length,"prev-icon":"mdi-menu-left","next-icon":"mdi-menu-right","total-visible":_vm.visible},on:{"input":_vm.changePage}})}
var staticRenderFns = []

export { render, staticRenderFns }